import { getLabel } from "../../hooks/use-labels";

export const metaData = () => {
  return {
    info: {
      title: "",
      subTitle: "",
      options: [
        {
          imgSrc: "/assets/icons/location.svg",
          label: "Your Address",
          link: "address-information",
          consumerDetail: ["address"],
        },
      ],
      text: "",
      footerText: "",
    },
    "review-screen": {
      title: "",
      subTitle: getLabel("applicationInReviewDescription"),
      imgSrc: "/assets/icons/check-purple.svg",
      text: getLabel("applicationInReviewLabel"),
      footerText: "Powered by Sayagie",
    },
    "on-completion": {
      title: "Information Completed",
      subTitle: "Please click submit button to continue.",
      footerText: "Powered by Sayagie",
    },
    rejected: {
      title: getLabel("ammendmentRequiredLabel"),
      subTitle: "Please update profile and submit again for verification.",
      footerText: "Powered by Sayagie",
    },
  };
};

export const consumerDetails = ["address"];
